<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-button (tap)="cancelReturn()">
                <ion-icon slot="icon-only" name="arrow-back"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-title>Cancelation</ion-title>
    </ion-toolbar>
</ion-header>

<ion-content #content>
    <datepicker [document]="documentTemp"></datepicker>
    <customer-return [document]="documentTemp" (customerChange)="listenCustomer($event)"
                     (documentChange)="listenDocument($event)"></customer-return>
    <site *ngIf="documentTemp.customer.name" [document]="documentTemp"></site>
    <contactdetails *ngIf="documentTemp.customer.name" [document]="documentTemp"></contactdetails>
    <items-return [document]="documentTemp"></items-return>
    <comments [document]="documentTemp"></comments>

    <ion-fab vertical="bottom" horizontal="end" slot="fixed">
        <ion-fab-button (tap)="saveReturn()" color="success">
            <ion-icon name="checkmark"></ion-icon>
        </ion-fab-button>
    </ion-fab>
</ion-content>
